import { Button, Dialog, TextField } from '@material-ui/core';
import { FormikHelpers, useFormik } from 'formik';
import { FormEvent, FormEventHandler, MouseEventHandler, useRef, useState } from 'react';
import en from '../../../lang/en-us';
import { CustomRadio } from '../../../lib/CustomRadio';
import Form, { InputType } from '../../../lib/Formik';
import * as yup from 'yup';
import { RouteComponentProps } from 'react-router';
import { useCallback } from 'react';
import { SubmitButton } from '../../../lib/Button';
import { emailRegex, panRegex, checkForOnlyAlphabets } from '../../../utils/constants';
import { useEffect } from 'react';
const {
    dashboard,
    signUp: { form },
} = en;

export const HOLDER = 'HOLDER';
export const NOMINEE = 'NOMINEE';
export const CLAIMANT = 'CLAIMANT';
export interface TransmissionFormType {
    pan: string;
    name: string;
    email: string;
    mobile: string;
}

interface TransmissionProps extends RouteComponentProps { }

const initialValues: TransmissionFormType = {
    pan: '',
    name: '',
    email: '',
    mobile: '',
};

const validationSchema = yup.object({
    pan: yup
        .string()
        .required(form.pan.validations.emptyError)
        .length(10, form.pan.validations.regexError)
        .test('regex', form.pan.validations.individualPan, (val) =>
            panRegex.test((val || '').toUpperCase()),
        ),
    mobile: yup
        .string()
        .required(form.mobile.validations.emptyError)
        .matches(/^[0]?[789]\d{9}$/, form.mobile.validations.regexError),
    name: yup
        .string()
        .required(dashboard.TransmissionRequest.form.validation.nameEmpty)
        .test('regex', 'Only alphabets are allowed', (val) => checkForOnlyAlphabets(val || ''))
        .test('len', 'Name is Required', (val) => val?.trim().length !== 0),
    email: yup
        .string()
        .required(dashboard.TransmissionRequest.form.validation.emailEmpty)
        .matches(emailRegex, form.email.validations.regexError),
});

const Fields: InputType[] = [
    {
        type: 'text',
        label: dashboard.TransmissionRequest.enterPan,
        name: 'pan',
        extraProps: { variant: 'outlined' },
    },
    {
        type: 'text',
        label: dashboard.TransmissionRequest.enterName,
        name: 'name',
        extraProps: { variant: 'outlined' },
    },
    {
        type: 'text',
        label: dashboard.TransmissionRequest.enterMobile,
        name: 'mobile',
        extraProps: { variant: 'outlined' },
    },
    {
        type: 'email',
        label: dashboard.TransmissionRequest.enterEmail,
        name: 'email',
        extraProps: { variant: 'outlined' },
    },
];

export function TransmissionRequest(props: TransmissionProps) {
    const [open, setOpen] = useState(true);
    useEffect(() => {
        if (props.history.action !== 'PUSH') {
            setOpen(false);
        }
    }, [props.history.action]);
    // const [role, setRole] = useState<string>('');
    const formik = useFormik({
        initialValues,
        onSubmit: (values: TransmissionFormType, action: FormikHelpers<TransmissionFormType>) => {
            action.setSubmitting(false);
            const { location } = props;
            props.history.push('/links/transmission-request-otp-mobile', {
                ...values,
                pan: formik.values.pan.toUpperCase(),
                name: formik.values.name.trim(),
            });
        },
        validationSchema,
    });

    // const handleSubmit = () => {
    //     let values = formik.values;
    //     props.history.push('/links/transmission-request-otp-mobile', {
    //         ...values,
    //     });
    // };

    const handleClose = () => {
        setOpen(false);
    };

    // const Radio = useCallback(
    //     () => (
    //         <CustomRadio
    //             extraClass="custom-radio"
    //             title={dashboard.TransmissionRequest.selectOption}
    //             name="select-option"
    //             list={[
    //                 {
    //                     label: dashboard.TransmissionRequest.IamFolioHolder,
    //                     value: HOLDER,
    //                 },
    //                 {
    //                     label: dashboard.TransmissionRequest.IamNominee,
    //                     value: NOMINEE,
    //                 },
    //                 {
    //                     label: dashboard.TransmissionRequest.IamClaimant,
    //                     value: CLAIMANT,
    //                 },
    //             ]}
    //             handleRadioChange={(value: string) => setRole(value)}
    //         />
    //     ),
    //     [],
    // );

    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="Go back" />
                </a>
                {dashboard.TransmissionRequest.TransmissionUnitHeading}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer transmission-request">
                {/* <h5>
                    {' '}
                    <span>{dashboard.TransmissionRequest.TransmissionRequestInfoSpan}</span>
                    {dashboard.TransmissionRequest.TransmissionRequestInfo}
                </h5> */}
                <div className="curved-bg-content-table">
                    {/* <Radio /> */}
                    {/* {!!role && ( */}
                    <div className="transmission-basic-details transmission-main-submit">
                        <p>{dashboard.TransmissionRequest.followingDetails}</p>
                        <h5>({dashboard.TransmissionRequest.info})</h5>
                        <Form
                            parentClass={'transmission-basic-detail-form'}
                            ui={Fields}
                            formik={formik}
                            submitButtonLabel={dashboard.TransmissionRequest.submitBtn}
                        />
                        {/* <div className="curved-bg-content-inner-bottom">
                            <SubmitButton
                                label={dashboard.TransmissionRequest.submitBtn}
                                className="customBtn"
                                onClick={handleSubmit}
                            />
                        </div> */}
                    </div>
                    {/* )} */}
                    {/* <p className="note">
                        <span>{dashboard.TransmissionRequest.TransmissionRequestInfoSpan}</span>
                        {dashboard.TransmissionRequest.multipleNomineesNote}
                    </p> */}
                </div>
            </div>
            <Dialog
                onClose={handleClose}
                maxWidth={'sm'}
                open={open}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dashboard.TransmissionRequest.modal.heading}</h3>
                    <p>{dashboard.TransmissionRequest.modal.info}</p>
                    <p>
                        <i> {dashboard.TransmissionRequest.modal.infoNote}</i>
                    </p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => props.history.push('/investor/signin')}
                        >
                            {dashboard.TransmissionRequest.modal.exit}
                        </Button>
                        <Button className="customBtn" onClick={handleClose}>
                            {dashboard.TransmissionRequest.modal.iAgree}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
